module.exports = __webpack_public_path__ + "static/media/diagram@x1.978efe5a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/projects/taptile/src/diagram@x1.svg
// module id = 430
// module chunks = 0